import { FlowStepEditor } from "../FlowStepEditor";
import { FlowExecutionData } from "../../../rule-engine-core/Flow/Engine/FlowExecutionData";
import { RunRuleSet } from "../../../rule-engine-core/Flow/Steps/Rules/RunRuleSet";

export class RunRuleSetEditor extends FlowStepEditor<RunRuleSet> {
    renderEditUI(): JSX.Element | null {
        return <div>run statement rule</div>;
    }

    // eslint-disable-next-line
    start(thread: string, data: FlowExecutionData): void {}
}
